import reviewData from './reviewData';
import appData from './appData';

const root = {
	reviewData,
	appData
};

export default root;
